module.exports = __webpack_public_path__ + "img/tangka01.8e4bf218.png";